<template>
  <div style="text-align: center;margin-top: 20px">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="param.page"
      :page-size="param.limit"
      layout="prev, pager, next, jumper"
      :total="param.total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'page',
  data () {
    return {}
  },
  props: {
    param: {
      type: Object,
      required: true
    },
  },
  methods: {
    handleCurrentChange (val) {
      // 分页点击事件
      this.param.page = val
      this.$emit('change')
    }
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
/deep/.el-pager{
  li{
    background: none;
  }
  .active{
    color: #b79255;
  }
}
/deep/.el-pagination button{
  background: none;
}
</style>
